export default (Vue) => {
  Vue.directive('btnauthelse', {
    inserted(el, binding) {
      const guid = binding.arg
      let btnCodeAuth = localStorage.getItem('btnAuthCodeList')
      btnCodeAuth = btnCodeAuth.split(',')
      let isShow = true
      btnCodeAuth.forEach((item) => {
        if (item === guid) {
          isShow = false
        }
      })
      if (!isShow) {
        el.remove()
      }
    }
  })
}
